// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import XngZone from "@conklin/App/Components/Common/XngZone";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";

export interface OrderDetailsInfoLayoutStyles {
    container?: InjectableCss;
    wrapper?: InjectableCss;
}

export const orderDetailsInfoLayoutStyles: OrderDetailsInfoLayoutStyles = {};

const styles = orderDetailsInfoLayoutStyles;
const OrderDetailsInfoLayout: FC<WidgetProps> = ({ id }) => {
    return (
        <StyledWrapper {...styles.container} data-test-selector="Order-Details-Info-Layout">
            <StyledWrapper {...styles.wrapper}>
                <XngZone contentId={id} zoneName="Content01" hint="Zone For Date" />
            </StyledWrapper>
            <StyledWrapper {...styles.wrapper}>
                <XngZone contentId={id} zoneName="Content03" hint="Zone for Order Status" />
            </StyledWrapper>
            <StyledWrapper {...styles.wrapper}>
                <XngZone contentId={id} zoneName="Content05" hint="Zone for Sales Order #" />
            </StyledWrapper>
            <StyledWrapper {...styles.wrapper}>
                <XngZone contentId={id} zoneName="Content02" hint="Zone for Payment Terms" />
            </StyledWrapper>
            <StyledWrapper {...styles.wrapper}>
                <XngZone contentId={id} zoneName="Content04" hint="Zone for Shipped Date" />
            </StyledWrapper>
            <StyledWrapper {...styles.wrapper}>
                <XngZone contentId={id} zoneName="Content06" hint="Zone for Delivery #" />
            </StyledWrapper>
            <StyledWrapper {...styles.wrapper}>
                <XngZone contentId={id} zoneName="Content07" hint="Zone for Order Source" />
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsInfoLayout,
    definition: {
        group: "Layout" as any,
        displayName: "Order Details Info Layout",
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
    },
};

export default widgetModule;
